/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XIcon64Regular = forwardRef('XIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M12.862 12.862a1.5 1.5 0 0 1 2.121 0L32 29.88l17.017-17.017a1.5 1.5 0 1 1 2.121 2.121L34.121 32l17.017 17.017a1.5 1.5 0 1 1-2.121 2.121L32 34.121 14.983 51.138a1.5 1.5 0 1 1-2.12-2.121L29.878 32 12.862 14.983a1.5 1.5 0 0 1 0-2.12Z" })));
});
